import { ContextError } from '@zg-rentals/log-error';

type ErrorProps = { name: string; message: string; errorCode: number; field?: string };
type PartialMessagesProps = { isBold?: boolean; text: string; url?: string };
type ErrorDetailsProps = {
  errors: Array<ErrorProps>;
  data?: { errorByFieldName?: Record<string, string> };
  message?: string;
  partialMessages?: Array<PartialMessagesProps>;
  messageCode?: string;
  ctaButtons?: Array<unknown>;
  leaseCards?: Array<unknown>;
};

export class DatarouterError extends ContextError {
  constructor(
    public readonly message: string,
    public readonly code: string,
    public readonly responseStatus: number,
    public readonly errorDetails?: unknown,
  ) {
    super('DatarouterError', { message, code, errorDetails, responseStatus });
  }

  public static is(error: unknown): error is DatarouterError {
    return error instanceof DatarouterError;
  }

  static getDisplayMessage(error: unknown, fallback = 'An error has occurred, please try again later'): string {
    return DatarouterError.is(error) ? error.message : fallback;
  }

  static getDisplayCode(error: unknown, fallback = ''): string {
    return DatarouterError.is(error) ? error.code || fallback : fallback;
  }

  static getErrorDetails(error: unknown): ErrorDetailsProps {
    if (DatarouterError.is(error)) {
      return error.errorDetails as ErrorDetailsProps;
    }
    return { errors: [] };
  }
}
